/*eslint-disable */
define(function (require) {
    var pageConfig = require('common/page-config');

    var format = function (number, showDecimals) {
        var decimalSeparator = (pageConfig.locale)?pageConfig.locale.decimalSeparator: '.';
        var thousandsSeparator = (pageConfig.locale)?pageConfig.locale.thousandsSeparator: ',';
        var currencyDecimals = (pageConfig.locale)?pageConfig.locale.currencyDecimals: 2;
        var decimals;

        // check typeof number
        if (typeof number !== 'number') {
            number = Number(number);
        }

        // check if number has decimals
        if (showDecimals) {
            decimals = String(number.toFixed(currencyDecimals)).split('.')[1];
        }

        // format int part of the number
        var formattedNumber = String(Math.floor(number));

        while (formattedNumber.match(/(\d+)(\d{3})/)) {
            formattedNumber = formattedNumber.replace(/(\d+)(\d{3})/, '$1' + thousandsSeparator + '$2');
        }

        // if there were decimals add it to the formattedNumber
        if (decimals) {
            formattedNumber += decimalSeparator + decimals;
        }

        return formattedNumber;
    };

    return {
        format: format
    };
});
